/**
 * get all countries in one subcat for subline
 * @param  {object} obj     a subcat, like data['Animals']['sheep']
 * @return {arr}            as below
 */
/*
[
  {
    name: "Canada",
    data: [56.33, 65, 25, ...]
  }, 
  {
    name: "Mexico",
    data: [24.03, 23, 3...]
  }, 
  ...
]
*/
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cntsInOneSubcatForLine = cntsInOneSubcatForLine;

function cntsInOneSubcatForLine(obj) {

  var output = [];

  for (var cnt in obj) {
    output.push({
      name: cnt,
      data: obj[cnt]
    });
  }

  output.sort(function (a, b) {
    return b.data.reduce(function (b1, b2) {
      return b1 + b2;
    }) - a.data.reduce(function (a1, a2) {
      return a1 + a2;
    });
  });
  //console.dir(output)
  return output;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9Vc2Vycy9rYXJlbi9Eb2N1bWVudHMvbXlfcHJvamVjdC9mb29kL3NyYy9qcy9kYXRhTW9kZWwvY250c0luT25lU3ViY2F0Rm9yTGluZS5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBa0JPLFNBQVMsc0JBQXNCLENBQUMsR0FBRyxFQUFDOztBQUV6QyxNQUFJLE1BQU0sR0FBRyxFQUFFLENBQUE7O0FBRWYsT0FBSSxJQUFJLEdBQUcsSUFBSSxHQUFHLEVBQUM7QUFDakIsVUFBTSxDQUFDLElBQUksQ0FBQztBQUNWLFVBQUksRUFBRSxHQUFHO0FBQ1QsVUFBSSxFQUFFLEdBQUcsQ0FBQyxHQUFHLENBQUM7S0FDZixDQUFDLENBQUE7R0FDSDs7QUFFRCxRQUFNLENBQUMsSUFBSSxDQUFDLFVBQUMsQ0FBQyxFQUFFLENBQUMsRUFBSTtBQUNuQixXQUFPLENBQUMsQ0FBQyxJQUFJLENBQUMsTUFBTSxDQUFDLFVBQUMsRUFBRSxFQUFFLEVBQUUsRUFBRztBQUFDLGFBQU8sRUFBRSxHQUFHLEVBQUUsQ0FBQTtLQUFDLENBQUMsR0FDOUMsQ0FBQyxDQUFDLElBQUksQ0FBQyxNQUFNLENBQUMsVUFBQyxFQUFFLEVBQUUsRUFBRSxFQUFHO0FBQUMsYUFBTyxFQUFFLEdBQUcsRUFBRSxDQUFBO0tBQUMsQ0FBQyxDQUFBO0dBQzVDLENBQUMsQ0FBQTs7QUFFRixTQUFPLE1BQU0sQ0FBQTtDQUNkIiwiZmlsZSI6Ii9Vc2Vycy9rYXJlbi9Eb2N1bWVudHMvbXlfcHJvamVjdC9mb29kL3NyYy9qcy9kYXRhTW9kZWwvY250c0luT25lU3ViY2F0Rm9yTGluZS5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogZ2V0IGFsbCBjb3VudHJpZXMgaW4gb25lIHN1YmNhdCBmb3Igc3VibGluZVxuICogQHBhcmFtICB7b2JqZWN0fSBvYmogICAgIGEgc3ViY2F0LCBsaWtlIGRhdGFbJ0FuaW1hbHMnXVsnc2hlZXAnXVxuICogQHJldHVybiB7YXJyfSAgICAgICAgICAgIGFzIGJlbG93XG4gKi9cbi8qXG5bXG4gIHtcbiAgICBuYW1lOiBcIkNhbmFkYVwiLFxuICAgIGRhdGE6IFs1Ni4zMywgNjUsIDI1LCAuLi5dXG4gIH0sIFxuICB7XG4gICAgbmFtZTogXCJNZXhpY29cIixcbiAgICBkYXRhOiBbMjQuMDMsIDIzLCAzLi4uXVxuICB9LCBcbiAgLi4uXG5dXG4qL1xuZXhwb3J0IGZ1bmN0aW9uIGNudHNJbk9uZVN1YmNhdEZvckxpbmUob2JqKXtcblxuICBsZXQgb3V0cHV0ID0gW11cblxuICBmb3IobGV0IGNudCBpbiBvYmope1xuICAgIG91dHB1dC5wdXNoKHtcbiAgICAgIG5hbWU6IGNudCxcbiAgICAgIGRhdGE6IG9ialtjbnRdXG4gICAgfSlcbiAgfVxuXG4gIG91dHB1dC5zb3J0KChhLCBiKSA9PntcbiAgICByZXR1cm4gYi5kYXRhLnJlZHVjZSgoYjEsIGIyKT0+e3JldHVybiBiMSArIGIyfSkgXG4gICAgLSBhLmRhdGEucmVkdWNlKChhMSwgYTIpPT57cmV0dXJuIGExICsgYTJ9KSBcbiAgfSlcbiAgLy9jb25zb2xlLmRpcihvdXRwdXQpXG4gIHJldHVybiBvdXRwdXRcbn0iXX0=